export const text = {
  VISIT_INFORMATION: 'Visit information',
  DATE: 'Date*',
  TIME: 'Time*',
  BOOKING_STATE: 'Booking state*',
  VISIT_TYPE: 'Visit type*',
  VISIT_METHOD: 'Visit method*',
  STATE_EMPTY_MSG: 'This provider is not licensed in',
  FIND_A_VISIT: 'Find a visit',
  DATE_WITHOUT_STAR: 'Date',
  TIME_WITHOUT_STAR: 'Time',
  VISIT_TYPE_WITHOUT_STAR: 'Visit type',
}
export const styles = {
  CALENDAR_DROP_DOWN_STYLE: {
    height: 150,
    marginTop: 10,
    boxSizing: 'border-box',
    top: -454,
  },
  TIME_DROP_DOWN_STYLE: {
    height: 235,
    marginTop: 8,
    boxSizing: 'border-box',
    top: 60,
  },
  DROP_DOWN_STYLE: {
    height: 150,
    marginTop: 8,
    boxSizing: 'border-box',
    top: 60,
    maxHeight: 150,
  },
  STATES_DROP_DOWN_STYLE: {
    height: 150,
    marginTop: 8,
    boxSizing: 'border-box',
    bottom: 65,
  },
  METHOD_DROP_DOWN_STYLE: {
    height: 'auto',
    marginTop: 5,
    boxSizing: 'border-box',
    top: 60,
  },
  CALENDAR_IMAGE_STYLE: {
    width: 24,
    height: 24,
    right: 16,
    top: 18,
    transform: 'none',
  },
  DROP_DOWN_MAIN_CONTAINER_STYLE: {
    width: 'calc(50% - 12px)',
    maxWidth: 'calc(50% - 12px)',
    display: 'flex',
    flex: 1,
  },
  DROP_DOWN_CONTAINER_STYLE: {
    width: 'calc(50% - 12px)',
    display: 'flex',
    flex: 1,
  },
  DROP_ITEM_STYLE: {
    wordBreak: 'break-word',
  },
  VISIT_TYPE_ITEM_STYLE: { wordBreak: 'break-word', overflowX: 'hidden' },
}
